import { render } from "./SuperAdmin.vue?vue&type=template&id=3a83733e&scoped=true&ts=true"
import script from "./SuperAdmin.vue?vue&type=script&lang=ts"
export * from "./SuperAdmin.vue?vue&type=script&lang=ts"

import "./SuperAdmin.vue?vue&type=style&index=0&id=3a83733e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\Cookies BIS\\Core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a83733e"]])

export default __exports__